import axios from 'axios';
import { getDomain } from './constants';
export const getOrgDetailsForThreePartURL = async (orgId) => {
  let data = {};
  try {
    data = await axios({
      url: `https://loginapp.${getDomain()}/development/getorgdetails`,
      'Content-Type': 'application/json',
      method: 'POST',
      data: {
        orgId: orgId
      }
    });
  } catch {
    return null;
  }
  return data;
};

export const getOrgDetailsForFivePartURL = async (orgId, envFromUrl) => {
  // let data = {};
  // try {
  //   data = await axios({
  //     // eslint-disable-next-line max-len
  //     url: `https://loginapp.${getDomain()}/development/getorgdetails`,
  //     'Content-Type': 'application/json',
  //     method: 'POST',
  //     data: {
  //       orgId: `${envFromUrl}:${orgId}`
  //     }
  //   });
  // } catch {
  //   return null;
  // }
  // return data;
  const data = { 'data': {} };
  try {
    data.data.envName = envFromUrl;
    data.data.orgId = orgId;
    data.data.envUrl = `https://${envFromUrl}lab.${getDomain()}`;
  } catch {
    return Promise.reject(new Error());
  }
  return Promise.resolve(data);
};
